<script lang="ts">
  import { compact, pick, uniq, values } from 'lodash-es'
  import Link from '#app/lib/components/link.svelte'
  import { workAuthorProperties } from '#entities/lib/editor/properties_per_subtype'
  import type { SerializedEntitiesByUris, SerializedEntity } from '#entities/lib/entities'
  import ClaimInfobox from './claim_infobox.svelte'

  const {
    entity,
    relatedEntities,
  }: {
    entity: SerializedEntity
    relatedEntities?: SerializedEntitiesByUris
  } = $props()

  const authorsUris = $derived.by(() => {
    return uniq(compact(values(pick(entity.claims, workAuthorProperties)).flat()))
  })
</script>

<div class="entity-list-compact">
  <div class="date">
    <ClaimInfobox
      values={entity.claims['wdt:P577']}
      prop="wdt:P577"
      omitLabel={true}
    />
  </div>

  <div class="title">
    <Link
      url={entity.pathname}
      text={entity.title}
      dark={true}
    />
    {#if entity.subtitle}
      <span class="subtitle">{entity.subtitle}</span>
    {/if}
  </div>
  <!-- TODO: display publisher by fetching more related entities
  (see function fetchRelatedEntities)
  {#if $screen.isLargerThan('$small-screen')}
    <div class="publisher">
      <ClaimInfobox
        values={entity.claims['wdt:P123']}
        prop="wdt:P123"
        omitLabel={true}
      />
    </div>
  {/if}
  -->
  <div class="authors">
    <!-- Using wdt:P50, as an alias for all the author properties here -->
    <ClaimInfobox
      values={authorsUris}
      prop="wdt:P50"
      omitLabel={true}
      entitiesByUris={relatedEntities}
    />
  </div>
</div>

<style lang="scss">
  @import "general/scss/utils";
  @import "entities/scss/entity_list_compact";
</style>
